import { render, staticRenderFns } from "./OrmQuoteRemarks.vue?vue&type=template&id=21b89ccc&scoped=true"
import script from "./OrmQuoteRemarks.vue?vue&type=script&lang=js"
export * from "./OrmQuoteRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b89ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b89ccc')) {
      api.createRecord('21b89ccc', component.options)
    } else {
      api.reload('21b89ccc', component.options)
    }
    module.hot.accept("./OrmQuoteRemarks.vue?vue&type=template&id=21b89ccc&scoped=true", function () {
      api.rerender('21b89ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/utilities/orm/components/OrmQuoteRemarks.vue"
export default component.exports